var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulTracks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h13a1 1 0 0 0 1-1zM15 17H5a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zM22 8a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1z",
    fill: "#E6E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.744 2.096-5.762 1.91c-.757.252-1.277.986-1.277 1.825v16.032c-1.214-.89-2.901-1.445-4.773-1.445-3.69 0-6.682 2.145-6.682 4.79 0 2.647 2.991 4.792 6.682 4.792 3.69 0 6.682-2.145 6.682-4.791V13.496l6.33-2.118A1.916 1.916 0 0 0 28.25 9.56V3.914c0-.614-.295-1.19-.79-1.55a1.903 1.903 0 0 0-1.716-.268z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulTracks);
export default __webpack_public_path__ + "static/media/icons-colorful-tracks.067bfa5d.svg";
export { ForwardRef as ReactComponent };